// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // assets path
  assets: '../assets',
  // phonebook api
  phone_api: 'https://appeng-win-webservices.psi.ch/api/Phonebook',
  // oase menu api
  oase_api: 'https://api.psi.ch/mealplanner/data',
  holiday_api: 'https://api.psi.ch/mealplanner/old',
  // food market api (contains all mealplanner v2 data including parkinnovarelunch and oasenewvisitor)
  foodmarket_api: 'https://api.psi.ch/mealplanner/data',
  // gfa-status image urls
  slsstatus: 'https://cas-status.psi.ch/sls-status.png?',
  hipainfo: 'https://cas-status.psi.ch/hipa-info.png?',
  hipastatus: 'https://cas-status.psi.ch/hipa-status.png?',
  proscanstatus: 'https://cas-status.psi.ch/proscan-status.png?',
  swissfelstatus: 'https://cas-status.psi.ch/sf-status.png?',
  // zpt image and calendar urls
  zptforecast: 'http://spotscan.ch/forecast/forecast-snapshot.png?',
  zptshifts: 'http://spotscan.ch/1715/shifts-1715-2019.PNG?',
  // corona

};

/*

1.	
2.	
3.	
4.	
5.	


 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
